import { render, staticRenderFns } from "./activities-outside.vue?vue&type=template&id=196a5db3&scoped=true&"
import script from "./activities-outside.vue?vue&type=script&lang=js&"
export * from "./activities-outside.vue?vue&type=script&lang=js&"
import style0 from "./activities-outside.vue?vue&type=style&index=0&id=196a5db3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a5db3",
  null
  
)

export default component.exports